<template>
  <div class="projectArea">
    <div class="projectInnerArea">
      <img :src="img['bg']" class="imageCover op20"/>

      <!-- <div class="positionAbsolute center t20 l50 h20 w20">
        <img :src="img['logo']" class="absoluteCenter h100">
      </div> -->

      <div class="positionAbsolute t40 l5 w100">
        <div class="title" v-html="$t('jureTitle')">
        </div>
      </div>

      <div class="positionAbsolute t50 l5 w100">
        <div class="description" v-html="$t('jureDescription')">
        </div>
      </div>

      <div class="positionAbsolute t75 l5 h20 w20">
        <img :src="img['playVideoIcon']" class="absoluteCenter h100"/>
        <div class="absoluteCenter h100 w100 touch hoverCursorPointer " @mouseup="openVideo()">
        </div>
      </div>

      <transition name="fade">
        <div class="absoluteCenter h100 w100 touch bgBlack" v-show="this.isShowVideo">
          <video ref="video" class="absoluteCenter h100 w100 touch" controls controlsList="nodownload" playsinline>
            <source :src="this.videoSrc" type="video/mp4">
          </video>
          
          <div class="positionAbsolute t3 r3 w10 h10 touch" @mouseup="closeVideo()">
            <img :src="img['closeIcon']" class="absoluteCenter h100" >
          </div>
        </div>
      </transition>

    </div>
    

  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'

export default {
  name: 'projectJure',
  data () {
    return {
      language : i18n.locale,

      videoSrc : './static/videos/jure.mp4',

      img : {
        logo : "static/images/project/ss/logo.webp",
        bg : "static/images/project/jure/bg.webp",
        playVideoIcon : "static/images/icon/playVideoBlack.webp",
        closeIcon : "static/images/icon/close.webp",

      },

      isShowVideo : false,

    }
  },
  mounted(){
    setTimeout(function(){
      store.state.projectLoaded += 1;
    },50)
  },
  created(){
    store.state.projectCount += 1;
  },
  methods:{
    openVideo(){
      this.isShowVideo = true;
      this.$refs.video.play();
    },

    closeVideo(){
      this.isShowVideo = false;
      this.$refs.video.currentTime = 0;
      this.$refs.video.pause();
    },

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },
}
</script>

<style  scoped src="@/assets/styles/projectStyle.css">
</style>

<style scoped>

@media (max-aspect-ratio: 4/3) {

}

</style>
<template>
  <div class="projectArea">
    <div class="projectInnerArea">
      <img :src="img['bg']" class="imageCover op20"/>

      <!-- <div class="positionAbsolute center t20 l50 h20 w20">
        <img :src="img['logo']" class="absoluteCenter h100">
      </div> -->

      <div class="positionAbsolute t40 l5 w100">
        <div class="title" v-html="$t('jureTitle')">
        </div>
      </div>

      <div class="positionAbsolute t50 l5 w100">
        <div class="description" v-html="$t('jureDescription')">
        </div>
      </div>

      <div class="positionAbsolute t75 l5 h20 w20">
        <img :src="img['playVideoIcon']" class="absoluteCenter h100"/>
        <div class="absoluteCenter h100 w100 touch hoverCursorPointer " @mouseup="openVideo()">
        </div>
      </div>

      <transition name="fade">
        <div class="absoluteCenter h100 w100 touch bgBlack" v-show="this.isShowVideo">
          <video ref="video" class="absoluteCenter h100 w100 touch" controls controlsList="nodownload" playsinline>
            <source :src="this.videoSrc" type="video/mp4">
          </video>
          
          <div class="positionAbsolute t3 r3 w10 h10 touch" @mouseup="closeVideo()">
            <img :src="img['closeIcon']" class="absoluteCenter h100" >
          </div>
        </div>
      </transition>

    </div>
    

  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'

export default {
  name: 'projectJure',
  data () {
    return {
      language : i18n.locale,

      videoSrc : './static/videos/jure.mp4',

      img : {
        logo : "static/images/project/ss/logo.webp",
        bg : "static/images/project/jure/bg.webp",
        playVideoIcon : "static/images/icon/playVideoBlack.webp",
        closeIcon : "static/images/icon/close.webp",

      },

      isShowVideo : false,

    }
  },
  mounted(){
    setTimeout(function(){
      store.state.projectLoaded += 1;
    },50)
  },
  created(){
    store.state.projectCount += 1;
  },
  methods:{
    openVideo(){
      this.isShowVideo = true;
      this.$refs.video.play();
    },

    closeVideo(){
      this.isShowVideo = false;
      this.$refs.video.currentTime = 0;
      this.$refs.video.pause();
    },

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },
}
</script>

<style  scoped src="@/assets/styles/projectStyle.css">
</style>

<style scoped>

@media (max-aspect-ratio: 4/3) {

}

</style>



// WEBPACK FOOTER //
// src/components/projects/projectJure.vue